import React, { useState } from "react";

import { Tab, Tabs } from "@mui/material";
import {
	FrontendCompanyWithAdditionalInfomation,
	FrontendUserInfo,
} from "node-library/dist/portal";
import { useTranslation } from "react-i18next";

import { useSnackbar } from "../../../common-components/toast/showToastMessage";

import OrderHistoryPageSkeleton from "../viewOrders/skeletonUI/orderHistoryPageSkeleton";
import ResultStructureTab from "./structureTabs/resultStructureTab";
import WorkflowStructureTab from "./structureTabs/workflowStructureTab";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	setCompany: React.Dispatch<
		React.SetStateAction<FrontendCompanyWithAdditionalInfomation | undefined>
	>;
	user: FrontendUserInfo | undefined;
}

export default function LabStructurePage(props: Props) {
	const { company, user, setCompany } = props;
	const { t: translation } = useTranslation();
	const { openSnackbar } = useSnackbar();

	const [loading, setLoading] = useState<boolean>(false);
	const [selectedTab, setSelectedTab] = useState<number>(0);

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setSelectedTab(newValue);
	};

	let resultsStructureTab: JSX.Element = (
		<ResultStructureTab
			company={company}
			setCompany={setCompany}
			user={user as FrontendUserInfo}
		/>
	);

	let workflowsStructureTab: JSX.Element = (
		<WorkflowStructureTab
			company={company}
			setCompany={setCompany}
			user={user as FrontendUserInfo}
		/>
	);

	const structurePageBody: React.ReactNode = (
		<div className="">
			<Tabs
				value={selectedTab}
				onChange={handleChange}
				aria-label="Structures"
				variant="scrollable"
				scrollButtons="auto"
				sx={{
					"& .MuiTab-root": {
						cursor: "pointer",
					},
				}}
			>
				<Tab label={translation("Results")} />
				<Tab label={translation("Workflow")} />
			</Tabs>
			<div style={{ marginTop: "10px" }}>
				{selectedTab === 0 && resultsStructureTab}
				{selectedTab === 1 && workflowsStructureTab}
			</div>
		</div>
	);

	const currentComponent = (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				gap: "20px",
				minHeight: "90vh",
				marginTop: "60px",
			}}
		>
			<div
				style={{
					flex: "1",
					display: "flex",
					flexDirection: "column",
					gap: "20px",
				}}
			>
				<div className="view-orders-page-header">
					<div className="typography-heading-01">
						{translation("LabStructures")}
					</div>
				</div>

				{loading ? <OrderHistoryPageSkeleton /> : structurePageBody}
			</div>
		</div>
	);
	return <div style={{ margin: "0 auto" }}>{currentComponent}</div>;
}
